import React from 'react'
import { Helmet } from 'react-helmet';
import Header4 from '../../components/header/header4/Header4';
import Contactinfosection3 from '../../components/contact_info_section/Contactinfosection3';
//import ContactFormSection1 from '../../components/contact_form_section/ContactFormSection1';
import Footer  from '../../components/footer/Footer';
import WhatsappSection from '../../components/whatsapp_section/WhatsappSection';
import BusinessDeatils from '../../components/business_details_section/BusinessDeatils';
import WhatsappCallBtn from '../../components/whatsapp_call_btn/WhatsappCallBtn';
export default function Contact() {
  return (
    <>
    <Helmet>
  <title>Contact Us | SARS India Liaison Pvt. Ltd. – Get in Touch for Compliance & Consulting Services</title>

  <meta
    name="description"
    content="Get in touch with SARS India Liaison Pvt. Ltd. for expert statutory compliance, environmental clearance, licensing, and consulting services across India. Call or email us today."
  />

  <meta
    name="keywords"
    content="Contact SARS India, SARS India Liaison Pvt. Ltd., compliance consulting contact, PESO consultants India, fire NOC contact, statutory approvals, environmental clearance services, regulatory consulting India"
  />

  <meta name="author" content="Sars India Liaison Pvt. Ltd." />

  <link rel="canonical" href="https://www.sarsindialiaison.com/contact" />
</Helmet>

  <Header4/>
  <WhatsappSection/>
  <BusinessDeatils/>
  <Contactinfosection3/>  
  {/* <ContactFormSection1/> */}
   <WhatsappCallBtn/>
  <Footer/>
  
    
    
    
    </>











  )
}
